import React from 'react';
import { cn } from '../../lib/utils';

const Skeleton = ({ className, ...props }) => {
  return (
    <div
      className={cn(
        "animate-pulse rounded-md bg-gradient-to-r from-gray-200 via-gray-100 to-gray-200 bg-[length:200%_100%]",
        className
      )}
      style={{
        animation: 'shimmer 1.5s ease-in-out infinite',
      }}
      {...props}
    />
  );
};

const SkeletonImage = ({ className, aspectRatio = 'square' }) => {
  const aspectClasses = {
    square: 'aspect-square',
    video: 'aspect-video',
    portrait: 'aspect-[3/4]',
    landscape: 'aspect-[4/3]'
  };

  return (
    <div className={cn("relative overflow-hidden rounded-lg", aspectClasses[aspectRatio], className)}>
      <Skeleton className="absolute inset-0 w-full h-full" />
    </div>
  );
};

const SkeletonCard = ({ className }) => {
  return (
    <div className={cn("p-6 rounded-xl bg-white border border-gray-100", className)}>
      <Skeleton className="w-14 h-14 rounded-xl mb-4" />
      <Skeleton className="h-6 w-3/4 mb-2" />
      <Skeleton className="h-4 w-full mb-1" />
      <Skeleton className="h-4 w-5/6" />
    </div>
  );
};

const SkeletonText = ({ lines = 3, className }) => {
  return (
    <div className={cn("space-y-2", className)}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton 
          key={i} 
          className={cn(
            "h-4",
            i === lines - 1 ? "w-4/5" : "w-full"
          )} 
        />
      ))}
    </div>
  );
};

export { Skeleton, SkeletonImage, SkeletonCard, SkeletonText };
